/*
hdx-header-directive.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
/*
/* This is an angular directive for header widget. It provides narrow, logo and sticky header apis.
 */

define('modules/shell/widgets/header/js/directive/hdx-header-directive',['jquery', 'angular'], function ($, angular) {
    'use strict';

    angular.module('headerDirectiveModule', []).directive('hdxHeader', function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {},
            //override default div margin
            template: '<div class="hdx-header">' +
                        '<div class="container" id="container">'+
                            '<div class="hdx-header-main-content" id="hdx-header-main-content">' +
                                '<ng-transclude class="header-content" ></ng-transclude>' +
                            '</div>' +
                        '</div>' +
                      '</div>' ,
            link: function (scope, element, attributes) {
                //prepend to hdx-header-main-content div
                var hElement = angular.element(element[0].children[0].firstChild);
                var containerElement = angular.element(element[0].firstChild);
                //narrow api
                if(attributes.narrow !== undefined){
                    hElement.addClass('hdx-header-sm');
                }
                //logo api
                if (attributes.logo !== undefined) {
                    var logoDiv = angular.element('<div></div>');
                    logoDiv.addClass('logo');
                    if (attributes.logo !== '') {
                        logoDiv.css({'background-image': 'url(\'' + attributes.logo + '\')'});
                    }
                    hElement.prepend(logoDiv);
                }
                //sticky api
                if(attributes.sticky !== undefined){
                    element.addClass('sticky');
                    $(window).scroll(function (event) {
                        element.css({left:'-'+event.target.body.scrollLeft+'px'});
                    });
                    var hdxHeaderDivMinHeight = $('div.hdx-header').height();
                    var headerMinHeightDiv = angular.element('<div style="height:'+hdxHeaderDivMinHeight+'px"></div>');
                    headerMinHeightDiv.insertAfter(element);
                }else {
                    element.removeClass('sticky');
                }
                //fluid api
                if(attributes.fluid !== undefined){
                    containerElement.removeClass('container');
                    containerElement.addClass('container-fluid');
                }
            }
        };
    });
});

